import React from 'react';
import { Button, Container, Row, Col } from "react-bootstrap";
import { useHistory, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import PageTitle from "../../components/common/PageTitle";
import UpdateResource from '../../components/resource/UpdateResource';

const EditResource = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const loading = useSelector(state => state.resource.loading);
  const { _resourceId } = useParams();


  return (
    <Container fluid className={`main-content-container px-4 ${loading && 'blur'}`} >
      <Row noGutters className="page-header py-4">
        <PageTitle sm="4" title="Edit Resource" subtitle="Resources" className="text-sm-left" />
        <Col id="hBtnHolder" className="hBtnHolder">
          <Button className="" variant="danger" onClick={() => history.push(`/resources-list`)}><i className="material-icons"></i> Cancel</Button>
        </Col>
      </Row>
      <hr />
      <UpdateResource resourceId={_resourceId} uploadBtn="hBtnHolder" />
    </Container>

  );
}

export default EditResource;
